// 管理用户登陆注册的状态
import { message } from 'antd';
import { action, observable } from 'mobx';
import { Auth } from '../models';
import HistoryStore from './history';
import ImageStore from './image';
import UserStore from './user';

class AuthStore {
    // 被观察状态
    // @observable isLogin = false;
    // @observable isLoading = false;
    @observable values = {
        username: '',
        password: ''
    };

    // 行为
    // @action setIsLogin(isLogin) {
    //     this.isLogin = isLogin;
    // }
    @action setUsername(username) {
        this.values.username = username;
    }
    @action setPassword(password) {
        this.values.password = password;
    }
    @action login() {
        // console.log('登陆中。。。');
        // this.isLoading = true;
        // setTimeout(() => {
        //     console.log('登陆成功！');
        //     this.isLogin = true;
        //     this.isLoading = false;
        // }, 1000);
        return new Promise((resolve, reject) => {
            Auth.login(this.values.username, this.values.password)
                .then(user => {
                    UserStore.pullUser();
                    resolve(user);
                    message.success('登陆成功！');

                })
                .catch(err => {
                    UserStore.resetUser();
                    message.error('登陆失败！');
                    reject(err)
                })
        })

    }
    @action register() {
        return new Promise((resolve, reject) => {
            Auth.register(this.values.username, this.values.password)
                .then(user => {
                    UserStore.pullUser();
                    resolve(user);
                    message.success('注册成功！');
                })
                .catch(err => {
                    UserStore.resetUser();
                    message.error('注册失败！');
                    reject(err)
                })
        })
    }
    @action logout() {
        Auth.logout();
        UserStore.resetUser();
        HistoryStore.reset();
        ImageStore.reset();
        message.success('注销成功！');
    }
}

export default new AuthStore();

